import { html, nothing } from 'lit';
import { type TefComs } from '@src/components/tef-coms.js';
import { service } from '@src/service/index.js';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@src/service/tracker.js';
import { save, cancelPage } from '@src/store/consents.js';
import { store } from '@src/store/index.js';
import { ConsentGroup } from '@src/types/common.js';

export const cancelButton = html`
<button
  class="button button-border"
  data-testid="button-cancel"
  @click=${

  () => {
    store.dispatch(cancelPage());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {},
    );
  }
}
> Abbrechen
</button>`;

export const saveButton = (changesMadePage: boolean) => html`
<button
  class="button button-default"
  data-testid="button-save"
  .disabled=${!changesMadePage}
  @click=${() => { store.dispatch(save()); }}>
  Speichern
</button>`;

export const consentGroupTemplate = (consentGroup: ConsentGroup, idx: number, tefComs: TefComs) => {
  const divider = html`<hr class="divider" aria-hidden="true" />`;

  return html`
    <div class="section">
      <tef-coms-consent-group
        .consentGroup=${consentGroup}
        .groupIndex=${idx}
        idx=${idx}
        .mode=${tefComs.mode}
        data-testid="group-${consentGroup.name.toLowerCase()}">
      </tef-coms-consent-group>
    </div>
    ${idx < (tefComs.displayConsentGroups).length - 1 ? divider : null}
  `;
};

export const buttonModeTemplate = (buttonModeButton: string, changesMadePage: boolean) => {
  const buttonActive = changesMadePage || buttonModeButton === 'saveActive';
  const showButton = !buttonModeButton || buttonModeButton.startsWith('save'); // save && saveActive

  return html`
    <div class="section section-buttons">
      <div class="form-row form-row--buttons">
        ${!buttonModeButton ? cancelButton : nothing}
        ${showButton ? saveButton(buttonActive) : nothing}
      </div>
    </div>
  `;
};
